import React from 'react';
import PropTypes from 'prop-types';
import { ProgressSurveyAnswer, ProgressSurveyQuestion } from 'utils/types';
import css from './MainRow.scss';
import { Table } from 'semantic-ui-react';
import StudentListStudentName from "../studentList/StudentListStudentName";
import ToggleButton from './ToggleButton';
import MobileFeedbackCell from './MobileFeedbackCell';
import DesktopQuestionCell from './DesktopQuestionCell';

export default class MainRow extends React.Component {

  get studentName() {
    return (
      <StudentListStudentName
        getStudentFolderLink={this.props.getStudentFolderLink}
        studentType="student"
        hasPhoto={this.props.student.hasPhoto}
        id={this.props.student.id}
        name={this.props.student.name}
        studentId={this.props.student.studentId}
        uuid={this.props.student.uuid}
      />
    );
  }

  get mobileFeedbackCell() {
    return (
      <MobileFeedbackCell
        isChecked={this.props.isChecked}
        availableQuestions={this.props.availableQuestions}
        answers={this.props.answers}
        plusButton={this.plusButton}
      />
    );
  }

  get desktopQuestionsCells() {
    return (
      this.props.availableQuestions.map(({ id, name }, i, array) => (
        <DesktopQuestionCell
          key={id}
          questionId={id}
          questionName={name}
          answers={this.props.answers}
          isChecked={this.props.isChecked}
          renderCheckbox={this.props.renderCheckbox}
          plusButton={this.isArrayLastElement(i, array) ? this.plusButton : null}
        />
      )));
  }

  get plusButton() {
    if ( !this.props.showToggleButton ) return null;
    return (
      <ToggleButton
        isExpanded={this.props.isExpanded}
        onClick={this.props.onToggleCommentsClick}
        isMobile={this.props.isMobile}
      />
    );
  }

  isArrayLastElement(index, array) {
    return index === array.length - 1;
  }

  get class() {
    return `${css['row']} ${this.props.isExpanded ? css['expanded'] : ""} ${this.props.hasError ? css['error'] : ""} `;
  }

  render() {
    return (
      <Table.Row className={this.class}>
        <Table.Cell>{this.studentName}</Table.Cell>
        {this.props.isMobile ? this.mobileFeedbackCell : this.desktopQuestionsCells}
      </Table.Row>
    );
  }
}

MainRow.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  showToggleButton: PropTypes.bool.isRequired,
  getStudentFolderLink: PropTypes.func.isRequired,
  student: ProgressSurveyAnswer.isRequired,
  availableQuestions: PropTypes.arrayOf(ProgressSurveyQuestion),
  onToggleCommentsClick: PropTypes.func.isRequired,
  isChecked: PropTypes.func.isRequired,
  onAnswerChanged: PropTypes.func.isRequired,
  renderCheckbox: PropTypes.func.isRequired,
  answers: PropTypes.array,
  isMobile: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired
};
